import Photo from "../ui/Photo";
import { VISIT_STEPS } from "../../data/salon";
import { toFa } from "../../lib/format";
import { useScrollProgress } from "../../lib/motion";

export default function Visit() {
  const [ref, progress] = useScrollProgress();

  const active = Math.min(
    VISIT_STEPS.length - 1,
    Math.floor(progress * VISIT_STEPS.length * 0.999)
  );

  return (
    <section className="visit" ref={ref}>
      <div className="visit__sticky">
        <div className="wrap wrap--wide visit__inner">
          <div className="visit__media">
            {VISIT_STEPS.map((s, i) => (
              <div
                key={s.step}
                className={`visit__frame${i === active ? " is-on" : ""}`}
                aria-hidden={i !== active}
              >
                <Photo src={s.photo} ratio="4 / 5" tint="warm" />
              </div>
            ))}

            <div className="visit__bar" aria-hidden="true">
              <span style={{ transform: `scaleX(${progress.toFixed(3)})` }} />
            </div>
          </div>

          <div className="visit__steps">
            <span className="eyebrow eyebrow--violet">THE VISIT</span>
            <h2 className="visit__title">چهار قدم، از در تا آینه</h2>

            <ol className="visit__list">
              {VISIT_STEPS.map((s, i) => (
                <li
                  key={s.step}
                  className={`vstep${i === active ? " is-on" : ""}${i < active ? " is-done" : ""}`}
                >
                  <span className="vstep__n">{toFa(s.step)}</span>
                  <div className="vstep__body">
                    <h3>
                      {s.title}
                      <span className="vstep__latin">{s.latin}</span>
                    </h3>
                    <p>{s.body}</p>
                  </div>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}
